var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-row',{staticClass:"status-message"},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('p',[_vm._v("手机号"+_vm._s(_vm.phone))])]),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('p',[_vm._v("您的密码已重置，请重新登录")])])],1),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("重新登录")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-438dd6ed","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/password/step3.vue
// module id = null
// module chunks = 